import { Observable } from 'rxjs';
import { InjectionToken } from '@angular/core';

export const UsersServiceInterfaceToken: InjectionToken<UsersServiceInterface> =
  new InjectionToken<UsersServiceInterface>('UsersServiceInterface');

export interface UserOptions {
  greetingName?: string;
  sendWelcomeEmail: boolean;
  locale?: string;
  phone?: string;
  welcomeMessage?: string;
  accountGroupId: string;
  partnerId: string;
}

export interface User {
  email: string;
  // This is in the format UID-XXXX
  userId: string;
  // This is in the format U-XXXX
  unifiedId: string;
  phone?: string;
  firstName?: string;
  lastName?: string;
  fullName?: string;
}

export interface UsersServiceInterface {
  users$: Observable<User[]>;
  hasMoreResults$: Observable<boolean>;
  createSMBUser(user: User, userOptions: UserOptions): Observable<User>;
  search(query: string): void;
  loadMore(): void;
  addUsersToAccount(partnerId: string, accountGroupId: string, userIds: string[]): Observable<unknown>;
}
